// API Configuration
const config = {
  // API base URL - will use environment variable or fallback to server
  API_BASE_URL: process.env.REACT_APP_API_URL || 'https://minapp.ek-store.ru',

  // Frontend URL for redirects
  FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || 'https://minapp.ek-store.ru',

  // API endpoints
  endpoints: {
    phones: '/api/phones',
    booking: '/api/booking',
    payment: '/api/payment',
    paymentStatus: '/api/payment-status'
  },

  // Telegram Mini App settings
  telegram: {
    botToken: process.env.REACT_APP_TELEGRAM_BOT_TOKEN,
    miniAppUrl: process.env.REACT_APP_MINI_APP_URL || 'https://minapp.ek-store.ru'
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${config.API_BASE_URL}${endpoint}`;
};

// Export configuration
export default config;